import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../contexts/auth';
import { formatDate } from '../viewTenant.component';
import styles from './tenantSubscriptionInfo.module.css';
import { useHasPermission } from '../../../../contexts/auth';

export const TenantSubscriptionInfo = () => {
  const { t } = useTranslation();
  const { currentUser, currentUserLoading } = useAuthContext();
  const tenant = currentUser?.tenant;
  const canViewSubscription = useHasPermission("payment.view_tenantsubscription");

  if (!canViewSubscription) {
    return null;
  }

  if (currentUserLoading || !tenant) {
    return (
      <Box className={styles.loadingContainer}>
        <CircularProgress />
      </Box>
    );
  }

  const statusMap: Record<string, string> = {
    T: t('Trial'),
    A: t('Active'),
    E: t('Expired'),
  };
  const subscriptionStatus = tenant?.subscription?.status ?? '';
  const subscriptionStatusLabel = subscriptionStatus
    ? t(statusMap[subscriptionStatus] ?? subscriptionStatus)
    : '';

  if (!tenant.subscription) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('No subscription information available')}
      </Typography>
    );
  }

  const { subscription } = tenant;

  return (
    <Box className={styles.container}>
      <Typography variant="subtitle1">
        {t('Plan')}: {subscription.tariff?.name || ''}
      </Typography>
      <Typography variant="subtitle1">
        {t('Status')}: {subscriptionStatusLabel}
      </Typography>
      <Typography variant="subtitle1">
        {t('Paid until')}: {formatDate(subscription.paid_until)}
      </Typography>
      <Typography variant="subtitle1">
        {t('Net price')}: {subscription.price_net || ''}
      </Typography>
      <Typography variant="subtitle1">
        {t('VAT')}: {subscription.vat || ''}
      </Typography>
      <Typography variant="subtitle1">
        {t('Total price')}: {subscription.total || ''}
      </Typography>
    </Box>
  );
};
